export enum SOCKET_TYPE {
  WEB = 'websocket',
  SIGNALR = 'signalR',
}
